module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "daterange-picker"
  }, [_c('datepicker', {
    ref: "fromDate",
    attrs: {
      "name": "from",
      "placeholder": _vm.fromPlaceholder,
      "language": _vm.language,
      "monday-first": true,
      "format": _vm.dateFormat,
      "disabled": _vm.fromDisabled,
      "disabled-picker": _vm.fromDisabledPicker,
      "calendar-button": true,
      "clear-button-icon": "glyphicon glyphicon-remove",
      "calendar-button-icon": "glyphicon glyphicon-time"
    },
    on: {
      "input": _vm.fromChange
    },
    model: {
      value: (_vm.value.from),
      callback: function($$v) {
        _vm.$set(_vm.value, "from", $$v)
      },
      expression: "value.from"
    }
  }), _vm._v(" "), _c('datepicker', {
    ref: "toDate",
    attrs: {
      "name": "to",
      "placeholder": _vm.toPlaceholder,
      "language": _vm.language,
      "monday-first": true,
      "format": _vm.dateFormat,
      "disabled": _vm.toDisabled,
      "calendar-button": true,
      "clear-button-icon": "glyphicon glyphicon-remove",
      "calendar-button-icon": "glyphicon glyphicon-time"
    },
    on: {
      "input": _vm.toChange,
      "cleared": _vm.cleared
    },
    model: {
      value: (_vm.value.to),
      callback: function($$v) {
        _vm.$set(_vm.value, "to", $$v)
      },
      expression: "value.to"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-037912cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateRangePicker.vue
// module id = 1223
// module chunks = 2